import { EquipmentTagPerfix, EquipmentType } from "@/types/common"
import { TagState } from "./modal"
import { padStart } from "lodash-es";



export interface TagGeneratorConfig {
  digits: number;
}

export class TagGenerator {
  private static instance: TagGenerator;
  private tagState: TagState | undefined;
  private config: TagGeneratorConfig = {digits: 3};
  private constructor() {}

  public static getInstance(state?: TagState, config?: TagGeneratorConfig): TagGenerator {
    if (!TagGenerator.instance) {
      TagGenerator.instance = new TagGenerator();
    }
    if (state) {
      TagGenerator.instance.init(state, config);
    }
    return TagGenerator.instance;
  }

  public init(tagStatus: TagState, config?: TagGeneratorConfig) {
    if (config) {
      this.config = config;
    }
    this.tagState = {...tagStatus}
  }

  public generateTag(type: EquipmentType): string {
    const perfix = EquipmentTagPerfix[type] || 'UNKNOWN'
    if (!this.tagState) {
      throw new Error("tagState is not initialized");
    }
    const num = this.tagState[perfix] || 0;
    const nextNum = num + 1;
    this.tagState[perfix] = nextNum;

    return `${perfix}${padStart(nextNum.toString(), this.config.digits, '0')}`;  
  }

  public getTagState(): TagState {
    return this.tagState!;
  }
}

export const tagGenerator = TagGenerator.getInstance();